import Toasted, { ToastOptions } from 'vue-toasted'

export default Toasted

export const options: ToastOptions = {
  position: 'top-center',
  duration: 3000,
}
